<template lang="pug">
.degug-home.line-height-default
  h1 デバッグ用ページ

  .degug-home__login
    a(@click='moveLoginAdmin()') 管理者ログインページ
  .degug-home__login
    a(@click='moveLoginStudent()') 生徒ログインページ
  .degug-home__logout
    a(@click='cookieLogout()') ログアウト
  .degug-home__update-cookie-expire
    a(@click='updateCookieExpire()') クッキー延長
  .degug-home__sandbox
    a(@click='sandboxEvent()') 簡易テスト用
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'

@Component
export default class DebugHome extends Mixins(LoginMethods) {
  private async created() {
    this.$loading.start()
    this.$logger.log('===== AuthBcbt')
    this.$logger.log(this.$bcbtCookies.authBcbt.get())
    this.$loading.complete()
  }

  private moveLoginAdmin() {
    window.location.href = '/debug/login-admin'
  }
  private moveLoginStudent() {
    window.location.href = '/debug/login-student'
  }
  private cookieLogout() {
    this.logout()
    window.location.href = '/debug'
  }
  private async updateCookieExpire() {
    await this.$bcbtCookies.updateCookieExpire()
  }

  /**
   * 簡易テスト用
   */
  private async sandboxEvent() {
    this.$loading.start()

    this.$logger.log('これは簡易テスト用のメソッドです。')
    this.$logger.log('中身を書き換えてテストに使用してください。')
    this.$logger.log('ただし、このファイルを修正してコミットしないでください。')
    await this.sleep(3000)

    this.$loading.complete()
  }

  /**
   * テスト用のウェイト処理
   */
  private async sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}
</script>

<style lang="stylus" scoped>
.degug-home
  position relative
  height 1000px
</style>
